import React, { createContext, useContext, useMemo } from 'react';
import { createDataClient } from './DataClientFactory';
import { useSelector } from 'react-redux';
import FeatureService from '@/services/feature-service';

const DataClientContext = createContext(null);

const resolveUserPlan = (user) => {
    if (!user) return 'basic';
    const features = FeatureService.resolveFeatures(user);
    return FeatureService.derivePlan(features);
};

export const DataClientProvider = ({ children }) => {
    const user = useSelector((state) => state.auth?.profile);
    const features = useMemo(() => FeatureService.resolveFeatures(user), [user]);
    const plan = useMemo(() => resolveUserPlan(user), [user]);
    const companyKey = user?.CompanyKey;

    const client = useMemo(() => createDataClient(features, { companyKey }), [features, companyKey]);

    const value = useMemo(() => ({
        client,
        plan,
        features,
        companyKey
    }), [client, plan, features, companyKey]);

    return (
        <DataClientContext.Provider value={value}>
            {children}
        </DataClientContext.Provider>
    );
};

export const useCRMDataClient = () => {
    const context = useContext(DataClientContext);
    if (!context) {
        console.warn("useCRMDataClient used outside of DataClientProvider. Falling back to default.");
        const defaultClient = createDataClient('basic');
        return { client: defaultClient, plan: 'basic', companyKey: null };
    }
    return context;
};
